import lang from '@/lang'

/**
 * AG Grid column defs for the partial-delivery drawer (list-v2).
 * Field names must match row objects built in PartialDeliveryDrawer (partial-delivery-drawer.tsx).
 */
export const getPurchasePartialDeliveryDrawerColumns = () => [
  {
    name: 'positionNo',
    headerName: 'Pos.',
    field: 'positionNo',
    active: true,
    filter: false,
    sortable: true,
    width: 72,
    minWidth: 72,
  },
  {
    name: 'articleNumber',
    headerName: lang.article.detail.label.number,
    field: 'articleNumber',
    active: true,
    sortable: true,
    cellRenderer: 'partialDeliveryArticleNumberCell',
    cellStyle: { display: 'flex', alignItems: 'center' },
  },
  {
    name: 'title',
    headerName: lang.purchase.partialDelivery.articleLabel,
    field: 'title',
    active: true,
    sortable: true,
  },
  {
    name: 'plannedDeliveryDate',
    headerName: lang.purchase.partialDelivery.plannedDeliveryDate,
    field: 'plannedDeliveryDateDisplay',
    active: true,
    sortable: true,
    filter: false,
  },
  {
    name: 'orderedAmount',
    headerName: lang.purchase.partialDelivery.orderedAmount,
    field: 'amount',
    active: true,
    sortable: true,
    filter: false,
  },
  {
    name: 'deliveredAmount',
    headerName: lang.purchase.partialDelivery.delivered,
    field: 'deliveredAmount',
    active: true,
    sortable: true,
    filter: false,
  },
  {
    name: 'incomingAmount',
    headerName: lang.purchase.partialDelivery.receivedNow,
    field: 'incomingAmount',
    active: true,
    sortable: false,
    filter: false,
    cellRenderer: 'partialDeliveryIncomingCell',
    suppressMenu: true,
    cellStyle: { display: 'flex', alignItems: 'center' },
  },
  {
    name: 'noteValue',
    headerName: lang.purchase.partialDelivery.note,
    field: 'noteValue',
    active: true,
    sortable: false,
    filter: false,
    cellRenderer: 'partialDeliveryNoteCell',
    suppressMenu: true,
    cellStyle: { display: 'flex', alignItems: 'center' },
  },
]
